import React, { useState, useRef, useEffect } from "react";
import "../Slider/Slider.css";

const Slider = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const sliderRef = useRef(null);
  const slides = ["s111.webp", "s222.webp", "s333.webp", "s4.webp"];

  const handleNextSlide = () => {
    setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlideIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length,
    );
  };

  const handleSelectSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") handleNextSlide();
      if (event.key === "ArrowLeft") handlePrevSlide();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      handleNextSlide();
    }, 4000); // 4 seconds interval

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [currentSlideIndex]);

  return (
    <div className="image-slider" ref={sliderRef}>
      <section className="slider__content">
        <main className="image-display">
          <img
            className="image-s"
            src={slides[currentSlideIndex]}
            alt={`Slide ${currentSlideIndex + 1}`}
          />
        </main>
      </section>
      <div className="slider-navigation">
        {slides.map((slide, index) => (
          <button
            key={index}
            className="nav-button"
            aria-selected={index === currentSlideIndex}
            onClick={() => handleSelectSlide(index)}
          >
            <img
              className="thumbnail"
              src={slide}
              alt={`Thumbnail ${index + 1}`}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Slider;
